import { render, staticRenderFns } from "./MimeType.vue?vue&type=template&id=6349c04d&"
import script from "./MimeType.vue?vue&type=script&lang=js&"
export * from "./MimeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6349c04d')) {
      api.createRecord('6349c04d', component.options)
    } else {
      api.reload('6349c04d', component.options)
    }
    module.hot.accept("./MimeType.vue?vue&type=template&id=6349c04d&", function () {
      api.rerender('6349c04d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/MimeType.vue"
export default component.exports